import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { Article } from '../_models/article';
import { Attachment } from '../_models/attachment';
import { Index } from '../_models/index';

@Injectable({
  providedIn: 'root'
})
export class ArticlesService {

  private locale: string = 'pt';
  private listMenu: Article[] = [];
  public menuSubject$: Subject<Article[]> = new Subject();

  constructor(
    private http: HttpClient
  ) {
  }

  all(): Observable<Article[]> {
    return this.http.get<Article[]>(`${this.locale}/articles`)
      .pipe(
        tap(_ => console.log("Articles fetched: ", _)),
        map(articles => {
          for (let index = 0; index < articles.length; index++) {
            let article = articles[index];
            article.dontShow = false;
            articles[index] = article;
          }

          return articles;
        }),
        catchError(this.handleError)
      );
  }

  menu(): Observable<Article[]> {
    return this.http.get<Article[]>(`${this.locale}/menu`)
      .pipe(
        tap(menu => {
          this.listMenu = menu;
          this.menuSubject$.next(this.listMenu);
        }),
        catchError(this.handleError)
      );
  }

  handleMenuSubject(): Promise<Article[]> {
    return new Promise(resolve => {
      if (typeof this.listMenu != 'undefined' && this.listMenu.length > 0) {
        resolve(this.listMenu);
      } else {
        this.menuSubject$.subscribe(menu => {
          resolve(menu);
        });
      }
    });
  }

  detail(id : number, all: boolean = false): Observable<Article> {
    return this.http.get<Article>(`${this.locale}/articles/${id}${all ? '/all' : ''}`)
      .pipe(
        tap(_ => console.log("Article fetched: ", _)),
        catchError(this.handleError)
      );
  }

  attachments(id : number): Observable<Attachment[]> {
    return this.http.get<Attachment[]>(`${this.locale}/articles/${id}/attachments`)
      .pipe(
        tap(_ => console.log("Attachments fetched: ", _)),
        catchError(this.handleError)
      );
  }

  indexes(id : number): Observable<Index[]> {
    return this.http.get<Index[]>(`${this.locale}/articles/${id}/indexes`)
      .pipe(
        map(indexes => {
          for (let index = 0; index < indexes.length; index++) {
            let indexObj = indexes[index];
            indexObj.dontShow = false;
            indexes[index] = indexObj;
          }

          return indexes;
        }),
        catchError(this.handleError)
      );
  }

  previous(id: number): Observable<Article> {
    return this.http.get<Article>(`${this.locale}/articles/${id}/previous`)
      .pipe(
        tap(_ => console.log("Article fetched: ", _)),
        catchError(this.handleError)
      );
  }

  next(id: number): Observable<Article> {
    return this.http.get<Article>(`${this.locale}/articles/${id}/next`)
      .pipe(
        tap(_ => console.log("Article fetched: ", _)),
        catchError(this.handleError)
      );
  }

  private handleError(error: Response) {
    console.error(JSON.stringify(error));
    console.error(error);
    return Observable.throw(error.statusText);
  }
}
